module.exports = __webpack_public_path__ + "static/media/468x60_0077_ro.a6a4ad60.jpg";